import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import YachtSales from "../pages/yacht-sales/page";
import YachtCharter from "../pages/yacht-charter/page";
import NewBuildManagement from "../pages/new-build-management/page";
import RefitManagement from "../pages/refit-management/page";
import CrewPlacement from "../pages/crew-placement/page";
import YachtFinancing from "../pages/yacht-financing/page";
import SuperYachtDetail from "../pages/superyacht-detail/page";
import SouthPacificCharter from "../pages/south-pacific-charter/page";
import SoundwavePage from "../pages/yacht-charter/soundwave/page";
import LadySPage from "../pages/yacht-charter/lady-s/page";
import OPariPage from "../pages/yacht-charter/o-pari/page";
import FlyingFoxPage from "../pages/yacht-charter/flying-fox/page";
import OctopusPage from "../pages/yacht-charter/octopus/page";
import AboutPage from "../pages/about/page";

// Destination Pages
import DestinationsIndex from "../pages/destinations/index/page";
import DestinationTemplate from "../pages/destinations/DestinationTemplate";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/yacht-sales",
    element: <YachtSales />,
  },
  {
    path: "/yacht-charter",
    element: <YachtCharter />,
  },
  {
    path: "/yacht-charter/soundwave",
    element: <SoundwavePage />,
  },
  {
    path: "/yacht-charter/lady-s",
    element: <LadySPage />,
  },
  {
    path: "/yacht-charter/o-pari",
    element: <OPariPage />,
  },
  {
    path: "/yacht-charter/flying-fox",
    element: <FlyingFoxPage />,
  },
  {
    path: "/yacht-charter/octopus",
    element: <OctopusPage />,
  },
  {
    path: "/superyacht/:id",
    element: <SuperYachtDetail />,
  },
  {
    path: "/destinations",
    element: <DestinationsIndex />,
  },
  {
    path: "/destinations/:slug",
    element: <DestinationTemplate />,
  },
  {
    path: "/new-build-management",
    element: <NewBuildManagement />,
  },
  {
    path: "/refit-management",
    element: <RefitManagement />,
  },
  {
    path: "/crew-placement",
    element: <CrewPlacement />,
  },
  {
    path: "/yacht-financing",
    element: <YachtFinancing />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
